/**
 * Is a half-space unicode character + asterisk
 * https://www.compart.com/en/unicode/U+2009
 */
export const REQUIRED_MARK = '\u2009*';
